import PlainDateInput from './PlainDateInput';

export default PlainDateInput;
